import Benefits from './components/Benefits';
import JoinUsNow from './components/JoinUsNow';
import TalkWords from './components/TalkWords';
import RealStory from './components/RealStory';

export default function Com({}: any) {
    return (
        <>
            <Benefits />
            <TalkWords />
            <JoinUsNow />
            <RealStory />
        </>
    );
}
